import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { LoadingService } from 'src/app/services/loading.service';
import { TagPage } from 'src/app/store/actions/ui.actions';
import { OnboardingProductsStore } from 'src/app/store/store';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {
  privateMode = false;
  staticAssetsUrl = environment.staticScripts.staticAssets;

  constructor(
    private store: Store<OnboardingProductsStore.AppState>,
    public loadingService: LoadingService) { }

  ngOnInit(): void {
    this.setService();
    setTimeout(() => {
      this.loadingService.loading = false;
    }, 100);
  }

  setService() {
    this.privateMode = (environment.mode === 'IN' || environment.mode === 'PF') ? true : false;
    this.privateMode ? this.store.dispatch(TagPage({text: 'mantencion-ya-cliente'})) : this.store.dispatch(TagPage({text: 'mantencion-sitio-publico'}));
  }

}
